import { Banner } from './src/index'

export default Banner
